export const LOANS_STATUSES = {
  CANCELED: 'CANCELED',
  PROCESS: 'PROCESS',
  REQUESTED: 'REQUESTED',
  CONCLUDED: 'CONCLUDED',
};
